import React, { useContext, useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import RelatedSupplyInformation from './related-supplier-information'
import RelatedSupplyCardAcceptance from './related-supplier-card-acceptance'
import RelatedSupplyCheckAcceptance from './related-supplier-check-acceptance'
import RelatedSupplierSupplyAchAcceptance from './related-supplier-ach-acceptance'
import RelatedSupplierHistory from './related-supplier-history'
import { useHistory } from 'react-router-dom'
import MasterSupplierHealth from '../SupplyComponent/master-supplier-health'
import { updateCompletenessScore } from '../../../../redux/actions/vendor'
import SupplierHistoricalPayments from '../SupplyComponent/historical-payments'
import Contacts from '../../../ContactsComponent/contacts'
import { AppContext } from '../../../../context'

const RelatedSupplyComponent = ({ relatedSupplierData, relatedSupplierId, onAssignedMaster, callers }) => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const {
    getSubscriptions
  } = useContext(AppContext);

  const {
    vendor: {
      isLoadingRelatedSupplier,
      relatedSupplierDetails
    },
  } = store

  const history = useHistory()
  const [isLocationMasterEditable, setIsLocationMasterEditable] = useState(false)
  const [isLocationBasedMaster, setIsLocationBasedMaster] = useState(false)
  const [status, setStatus] = useState('')
  const [locationMasterStatus, setLocationMasterStatus] = useState('')
  const [isLocationMaster, setIsLocationMaster] = useState(false)  // related supplier is location based master or child supplier
  const [currentTab, setCurrentTab] = useState('contacts')

  useEffect(() => {
    // history.push('/suppliers/relatedsupplier/' + relatedSupplierId)
    relatedSupplierId ?
      history.push('/suppliers/relatedsupplier/' + relatedSupplierId)
      :
      relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id ?
        history.push('/suppliers/relatedsupplier/' + relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id)
        :
        history.push('/suppliers/')
  }, [relatedSupplierId, history])

  useEffect(() => {
    if (relatedSupplierData && Object.keys(relatedSupplierData).length > 0 ? (relatedSupplierData?.primaryMasterInfo && relatedSupplierData?.masterSupplierInfo?.baseInfo?.masterId !== null) : (relatedSupplierDetails?.relatedSupplierInfo?.primaryMasterInfo && relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.masterId !== null)) {
      if (relatedSupplierData && Object.keys(relatedSupplierData).length > 0) {
        setIsLocationMasterEditable(relatedSupplierData?.primaryMasterInfo?.cardInfo?.isAcceptGlobalAcceptance === false ? true : false)
      } else {
        setIsLocationMasterEditable(relatedSupplierDetails?.relatedSupplierInfo?.primaryMasterInfo?.cardInfo?.isAcceptGlobalAcceptance === false ? true : false)
      }
      setIsLocationBasedMaster(true)
    } else {
      setIsLocationMasterEditable(false)
      setIsLocationBasedMaster(false)
    }

    if (relatedSupplierData && Object.keys(relatedSupplierData).length > 0 && relatedSupplierData?.masterSupplierInfo && Object?.keys(relatedSupplierData?.masterSupplierInfo)?.length > 0) {
      if (!relatedSupplierData?.masterSupplierInfo?.detailInfo?.approvedByQA || relatedSupplierData?.masterSupplierInfo?.detailInfo?.approvedByQA === 6) {
        setStatus('Pending')
      } else if (relatedSupplierData?.masterSupplierInfo?.detailInfo?.approvedByQA === 7) {
        setStatus('Rejected')
      } else if (relatedSupplierData?.masterSupplierInfo?.detailInfo?.approvedByQA === 8) {
        setStatus('Approved')
      } else if (relatedSupplierData?.masterSupplierInfo?.detailInfo?.approvedByQA === 9 || relatedSupplierData?.masterSupplierInfo?.baseInfo?.isInCalls) {
        setStatus('In Calls')
      }
    }

    if (relatedSupplierData && Object.keys(relatedSupplierData).length > 0 && relatedSupplierData?.baseInfo?.isMaster && relatedSupplierData?.baseInfo?.masterId !== null && relatedSupplierData?.baseInfo?.primaryMasterId !== null) {
      setIsLocationMaster(true)
    }
  }, [relatedSupplierData])

  useEffect(() => {
    let locationMasterStatus = ''
    if (relatedSupplierDetails && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.isMaster && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.masterId !== null && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.primaryMasterId !== null) {
      if (!relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.approvedByQA || relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.approvedByQA === 6) {
        locationMasterStatus = 'Pending'
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.approvedByQA === 7) {
        locationMasterStatus = 'Rejected'
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.approvedByQA === 8) {
        locationMasterStatus = 'Approved'
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.approvedByQA === 9 || relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.isInCalls) {
        locationMasterStatus = 'In Calls'
      }
    }
    if (relatedSupplierDetails && Object.keys(relatedSupplierDetails)?.length > 0 && relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo && Object?.keys(relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo)?.length > 0) {
      if (!relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo?.approvedByQA || relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo?.approvedByQA === 6) {
        setStatus('Pending')
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo?.approvedByQA === 7) {
        setStatus('Rejected')
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo?.approvedByQA === 8) {
        setStatus('Approved')
      } else if (relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo?.approvedByQA === 9 || relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.isInCalls) {
        setStatus('In Calls')
      }
    }
    setLocationMasterStatus(locationMasterStatus)
  }, [relatedSupplierDetails])

  const cardColumns = [
    {
      name: 'isAcceptAmericanExpress',
      label: 'Accepts American Express',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMasterCard',
      label: 'Accepts Mastercard',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisa',
      label: 'Accepts Visa',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForAmericanExpress',
      label: 'Has Acceptance Conditions for American Express',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForMastercard',
      label: 'Has Acceptance Conditions for Mastercard',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForVisa',
      label: 'Has Acceptance Conditions for Visa',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForDiscover',
      label: 'Has Acceptance Conditions for Discover',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByEmail',
      label: 'Accepts Card Payment by Email',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByFax',
      label: 'Accepts Card Payment by Fax',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByPhone',
      label: 'Accepts Card Payment by Phone',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByOnlinePortal',
      label: 'Accepts Card Payment by Online Portal',
      datatype: 'boolean'
    },
    {
      name: 'americanExpressPercentFee',
      label: 'American Express % Fee',
      datatype: 'percent',
    },
    {
      name: 'americanExpressDollarFee',
      label: 'American Express $ Fee',
      datatype: 'currency',
    },
    {
      name: 'americanExpressMinPaymnet',
      label: 'American Express Min Payment',
      datatype: 'currency',
    },
    {
      name: 'americanExpressMaxPayment',
      label: 'American Express Max Payment',
      datatype: 'currency',
    },
    {
      name: 'mastercardPercentFee',
      label: 'Mastercard % Fee',
      datatype: 'percent',
    },
    {
      name: 'mastercardDollarFee',
      label: 'Mastercard $ Fee',
      datatype: 'currency',
    },
    {
      name: 'mastercardMinPayment',
      label: 'Mastercard Min Payment',
      datatype: 'currency',
    },
    {
      name: 'mastercardMaxPayment',
      label: 'Mastercard Max Payment',
      datatype: 'currency',
    },
    {
      name: 'visaPercentFee',
      label: 'Visa % Fee',
      datatype: 'percent',
    },
    {
      name: 'visaDollarFee',
      label: 'Visa $ Fee',
      datatype: 'currency',
    },
    {
      name: 'visaMinPayment',
      label: 'Visa Min Payment',
      datatype: 'currency',
    },
    {
      name: 'visaMaxPayment',
      label: 'Visa Max Payment',
      datatype: 'currency',
    },
    {
      name: 'isCredentialsRequired',
      label: 'IS Credentials Required',
      datatype: 'boolean'
    },
    {
      name: 'cardDiscountValue',
      label: 'Card Discount Value',
    },
    {
      name: 'tokenType',
      label: 'Token Configuration',
    },
    {
      name: 'cardPaymentByPhoneValue',
      label: 'Phone',
      datatype: 'integer',
    },
    {
      name: 'cardPaymentByFaxValue',
      label: 'Fax',
      datatype: 'integer',
    },
    {
      name: 'isAcceptEcommercePortal',
      label: 'E-Commerce',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptPortal',
      label: 'Portal',
      datatype: 'boolean'
    },
    {
      name: 'isAccept3rdPartyPortal',
      label: '3rd Party Portal',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptInAppPortal',
      label: 'In-App',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptPointOfSalePortal',
      label: 'Point of Sale',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardAuthorizationForm',
      label: 'Card Authorization Form',
      datatype: 'boolean'
    },
    {
      name: 'cardAuthorizationFormFile',
      label: 'Card Authorization Form File',
    },
    {
      name: 'thirdPartyPortalUrl',
      label: '3rd Party Portal URL',
    },
    {
      name: 'portalUrl',
      label: 'Portal URL',
    },

    {
      name: 'advancedAcceptanceEnabled',
      label: 'Advanced Acceptance Enabled',
      datatype: 'boolean',
    },
    {
      name: 'amexProcessingFeeType',
      label: 'Amex Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexProcessingFeeValue',
      label: 'Amex Processing Fee Value',
    },
    {
      name: 'amexMinPaymentFeeType',
      label: 'Amex Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexMinPaymentFeeValue',
      label: 'Amex Minimum Payment Fee Value',
    },
    {
      name: 'amexMaxPaymentFeeType',
      label: 'Amex Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexMaxPaymentFeeValue',
      label: 'Amex Maximum Payment Fee Value',
    },
    {
      name: 'amexIncrementalFeeType',
      label: 'Amex Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexIncrementalFeeValue',
      label: 'Amex Incremental Fee Value',
    },
    {
      name: 'amexIncrementalPaymentAmount',
      label: 'Amex Incremental Payment Amount',
    },
    {
      name: 'visaProcessingFeeType',
      label: 'Visa Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaProcessingFeeValue',
      label: 'Visa Processing Fee Value',
    },
    {
      name: 'visaMinPaymentFeeType',
      label: 'Visa Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaMinPaymentFeeValue',
      label: 'Visa Minimum Payment Fee Value',
    },
    {
      name: 'visaMaxPaymentFeeType',
      label: 'Visa Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaMaxPaymentFeeValue',
      label: 'Visa Maximum Payment Fee Value',
    },
    {
      name: 'visaIncrementalFeeType',
      label: 'Visa Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaIncrementalFeeValue',
      label: 'Visa Incremental Fee Value',
    },
    {
      name: 'visaIncrementalPaymentAmount',
      label: 'Visa Incremental Payment Amount',
    },
    {
      name: 'mastercardProcessingFeeType',
      label: 'Mastercard Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardProcessingFeeValue',
      label: 'Mastercard Processing Fee Value',
    },
    {
      name: 'mastercardMinPaymentFeeType',
      label: 'Mastercard Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardMinPaymentFeeValue',
      label: 'Mastercard Minimum Payment Fee Value',
    },
    {
      name: 'mastercardMaxPaymentFeeType',
      label: 'Mastercard Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardMaxPaymentFeeValue',
      label: 'Mastercard Maximum Payment Fee Value',
    },
    {
      name: 'mastercardIncrementalFeeType',
      label: 'Mastercard Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardIncrementalFeeValue',
      label: 'Mastercard Incremental Fee Value',
    },
    {
      name: 'mastercardIncrementalPaymentAmount',
      label: 'Mastercard Incremental Payment Amount',
    },
    {
      name: 'isAcceptCardPaymentTerms',
      label: 'Accepts Card Payment Terms',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardDiscount',
      label: 'Accepts Card Discount',
      datatype: 'boolean'
    },
    {
      name: 'cardPaymentTermsvalue',
      label: 'Payment Terms',
    },
    {
      name: 'cardDiscountType',
      label: 'Card Discount Type',
    },
    {
      name: 'discoverProcessingFeeType',
      label: 'Discover Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverProcessingFeeValue',
      label: 'Discover Processing Fee Value',
    },
    {
      name: 'discoverMinPaymentFeeType',
      label: 'Discover Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverMinPaymentFeeValue',
      label: 'Discover Minimum Payment Fee Value',
    },
    {
      name: 'discoverMaxPaymentFeeType',
      label: 'Discover Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverMaxPaymentFeeValue',
      label: 'Discover Maximum Payment Fee Value',
    },
    {
      name: 'discoverIncrementalFeeType',
      label: 'Discover Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverIncrementalFeeValue',
      label: 'Discover Incremental Fee Value',
    },
    {
      name: 'discoverIncrementalPaymentAmount',
      label: 'Discover Incremental Payment Amount',
    },
    {
      name: 'cardPhoneExtension',
      label: 'Card Phone Extension',
    },
    {
      name: 'isAcceptAcceptancePerCard',
      label: 'Accepts Acceptance Per Card',
      datatype: 'boolean'
    },
    {
      name: 'amexSecondProcessingFeeType',
      label: 'Amex Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexSecondProcessingFeeValue',
      label: 'Amex Second Processing Fee Value',
    },
    {
      name: 'visaSecondProcessingFeeType',
      label: 'Visa Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaSecondProcessingFeeValue',
      label: 'Visa Second Processing Fee Value',
    },
    {
      name: 'mastercardSecondProcessingFeeType',
      label: 'Master Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardSecondProcessingFeeValue',
      label: 'Master Second Processing Fee Value',
    },
    {
      name: 'discoverSecondProcessingFeeType',
      label: 'Discover Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverSecondProcessingFeeValue',
      label: 'Discover Second Processing Fee Value',
    },
    {
      name: 'isAcceptProductSpecific',
      label: 'Accepts Card Product Specific',
      datatype: 'boolean'
    },
    {
      name: 'productSpecificOptions',
      label: 'Product Specific Options',
    },
    {
      name: 'isAcceptPOTSPhone',
      label: 'Accepts POTS Phone',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptIVRPhone',
      label: 'Accepts IVR Phone',
      datatype: 'boolean'
    },
    {
      name: 'cardPaymentIVRPhone',
      label: 'IVR Phone',
      datatype: 'integer',
    },
    {
      name: 'isAcceptAmexVariableFee',
      label: 'Accepts Amex Variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisaVariableFee',
      label: 'Accepts Visa variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMasterCardVariableFee',
      label: 'Accepts MasterCard Variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'emailRemitRequirements',
      label: 'Email Remittance Requirements'
    },
    {
      name: 'phoneRemitRequirements',
      label: 'Phone Remittance Requirements'
    },
    {
      name: 'faxRemitRequirements',
      label: 'Fax Remittance Requirements'
    },
    {
      name: 'onlineRemitRequirements',
      label: 'Online Remittance Requirements'
    },
    {
      name: 'posRemitRequirements',
      label: 'POS Remittance Requirements'
    },
    {
      name: 'isAcceptAmexCardConditions',
      label: 'Accepts Amex Card Conditions',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisaCardConditions',
      label: 'Accepts Visa Card Conditions',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMastercardCardConditions',
      label: 'Accepts Mastercard Card Conditions',
      datatype: 'boolean'
    }
  ]

  const achColumns = [
    {
      name: 'isAcceptAchPayments',
      label: 'Accept ach payments',
    },
    {
      name: 'achInstructions',
      label: 'Ach Instructions',
    },
    {
      name: 'bankAccountNumber',
      label: 'Bank Account Number',
    },
    {
      name: 'bankRoutingNumber',
      label: 'Bank Routing Number',
    },
    {
      name: 'emailAch',
      label: 'Email Ach',
    },
    {
      name: 'bankName',
      label: 'Bank Name',
    },
    {
      label: 'Is ACH Paid Through Portal?',
      name: 'isAchThroughPortal'
    },
    {
      label: 'ACH Portal URL',
      name: 'achPortalURL'
    }
  ]

  const checkColumns = [
    {
      label: 'Do they accept Check payments?',
      name: 'isAcceptCheckPayments',
      defaultValue: null,
    },
    {
      label: 'Do they offer Cash Discount?',
      name: 'isAcceptCashDiscount',
      defaultValue: null,
    },
    {
      label: 'Cash Discount Type?',
      name: 'cashDiscountType',
      defaultValue: 'Percentage',
    },
    {
      label: 'Cash Discount Value?',
      name: 'cashDiscountValue',
      defaultValue: null,
    },
    {
      label: 'Check Remittance Address matches Supplier Address?',
      name: 'isMatchVendorAddress',
      defaultValue: false,
    },
    {
      label: 'Check Address Line 1',
      name: 'checkAddress1',
      defaultValue: null,
    },
    {
      label: 'Check Address Line 2',
      name: 'checkAddress2',
      defaultValue: null,
    },
    {
      label: 'Check City',
      name: 'checkCity',
      defaultValue: null,
    },
    {
      label: 'Check State',
      name: 'checkState',
      defaultValue: null,
    },
    {
      label: 'Check Zip',
      name: 'checkZip',
      defaultValue: null,
    },
    {
      label: 'Check Country',
      name: 'checkCountry',
      defaultValue: null,
    },
    {
      label: 'Payment Terms',
      name: 'cashPaymentTermsValue',
      defaultValue: 'Upon Receipt',
    },
    {
      label: 'Cash Payment terms?',
      name: 'isAcceptCashPaymentTerms',
      defaultValue: null,
    },
  ]

  const historyTabs = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Notes',
      value: 'notes',
    },
    {
      label: 'Files',
      value: 'files',
    },
    {
      label: 'Change Log',
      value: 'changelog',
    },
    {
      label: 'Emails',
      value: 'email',
    }

  ]

  const tabs = [
    { label: 'Contacts', value: 'contacts' },
    { label: 'Card Acceptance', value: 'card' },
    { label: 'Check Acceptance', value: 'check' },
    { label: 'ACH Acceptance', value: 'ach' }
  ]

  const handleUpdateCompletenessScore = (supplierId) => {
    if (supplierId) {
      dispatch(updateCompletenessScore(supplierId))
    }
  }

  const handleClickTab = (tab) => {
    tab !== currentTab && setCurrentTab(tab)
  }

  useEffect(() => {
    getSubscriptions()
  }, []);

  return (
    <>
      {(relatedSupplierId || relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id) ?
        <div className={`assign-vendor-supply ${relatedSupplierData && Object.keys(relatedSupplierData).length > 0 && relatedSupplierData?.baseInfo?.masterId && (isLoadingRelatedSupplier) ? 'loading' : ''}`}>
          {(isLoadingRelatedSupplier) ? <LoaderComponent />
            :
            <>
              <div className='mb-3'>
                {isLocationMaster &&
                  <MasterSupplierHealth
                    qaStatus={locationMasterStatus}
                    supplierData={relatedSupplierDetails?.relatedSupplierInfo}
                    masterType={'location'}
                  />
                }
                {
                  relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id && (
                    <MasterSupplierHealth
                      qaStatus={status}
                      supplierData={relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo}
                      masterType={'master'}
                    />
                  )
                }
              </div>

              {((relatedSupplierData && Object.keys(relatedSupplierData).length > 0) || (Object.keys(relatedSupplierDetails?.relatedSupplierInfo).length > 0)) ? // relatedSupplierData.length
                <>
                  <RelatedSupplyInformation
                    isLocationMasterEditable={isLocationMasterEditable}
                    isLocationBasedMaster={isLocationBasedMaster}
                    onAssignedMaster={(relatedSupplierId) => { onAssignedMaster(relatedSupplierId) }}
                    onUpdateCompletenessScore={handleUpdateCompletenessScore}
                  />
                  <div className='master-supplier-history'>
                    <RelatedSupplierHistory
                      historyTabs={historyTabs}
                      callers={callers}
                    />
                  </div>

                  <div className={`list-tabs d-flex align-items-end border border-top-0 border-start-0 border-end-0 border-1 mt-5`}>
                    {
                      tabs.map(tab => (
                        <button
                          key={tab.value}
                          type="button"
                          className={`h4 border border-1 border-bottom-0 rounded-top mb-0 page-tab list-tab pt-2 pb-2 p-4 text-black fw-bold me-3${currentTab === tab.value ? ' selected bg-dark-blue text-white pt-3 pb-3' : ''}`}
                          onClick={() => { handleClickTab(tab.value) }}
                          disabled={isLoadingRelatedSupplier}
                        >
                          {tab.label}
                        </button>
                      ))
                    }
                  </div>

                  {currentTab === 'contacts' && (
                    <Contacts contactsData={relatedSupplierDetails?.relatedSupplierInfo?.contacts || []} onGetContactsData={() => {}} />
                  )}

                  <div className="supply-acceptance related-supply-acceptance flex-column">
                    {currentTab === 'card' && (
                      <div className="col">
                        <RelatedSupplyCardAcceptance
                          isLocationMasterEditable={isLocationMasterEditable}
                          cardColumns={cardColumns}
                          isLocationBasedMaster={isLocationBasedMaster}
                          onUpdateCompletenessScore={handleUpdateCompletenessScore}
                        />
                      </div>
                    )}
                    {currentTab === 'check' && (
                      <div className="col">
                        <RelatedSupplyCheckAcceptance
                          isLocationMasterEditable={isLocationMasterEditable}
                          checkColumns={checkColumns}
                          isLocationBasedMaster={isLocationBasedMaster}
                          onUpdateCompletenessScore={handleUpdateCompletenessScore}
                        />
                      </div>
                    )}
                    {currentTab === 'ach' && (
                      <div className="col">
                        <RelatedSupplierSupplyAchAcceptance
                          isLocationMasterEditable={isLocationMasterEditable}
                          achColumns={achColumns}
                          isLocationBasedMaster={isLocationBasedMaster}
                          onUpdateCompletenessScore={handleUpdateCompletenessScore}
                        />
                      </div>
                    )}
                    {/* <div className="col">
                      <RelatedSupplyCheckAcceptance
                        isLocationMasterEditable={isLocationMasterEditable}
                        checkColumns={checkColumns}
                        isLocationBasedMaster={isLocationBasedMaster}
                        onUpdateCompletenessScore={handleUpdateCompletenessScore}
                      />
                      <RelatedSupplierSupplyAchAcceptance
                        isLocationMasterEditable={isLocationMasterEditable}
                        achColumns={achColumns}
                        isLocationBasedMaster={isLocationBasedMaster}
                        onUpdateCompletenessScore={handleUpdateCompletenessScore}
                      />
                    </div> */}
                  </div>

                  {isLocationMaster && (
                    <SupplierHistoricalPayments
                      masterId={relatedSupplierId ? relatedSupplierId : relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id}
                    />
                  )}
                </>
                :
                <h4 className="no-data text-black mb-0 fw-bold"> No Related Supplier found with this ID. Please select any other Related Supplier. </h4>
              }
            </>
          }

        </div>
        :
        <div className={`assign-vendor-supply`}>
          <h4 className="no-data text-black mb-0 fw-bold"> No data found. Please select any child supplier to view the Information of Related Supplier. </h4>
        </div>
      }
    </>
  )
}
export default RelatedSupplyComponent